var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },
  {
    id: "change_time",
    label: "更新日",
    tab_size: 20,
    type: types.INPUT
  },
  {
    id: "user_id",
    label: "更新者(id)",
    tab_size: 10,
    type: types.INPUT
  },
  {
    id: "user_shimei",
    label: "更新者",
    tab_size: 10,
    type: types.INPUT
  },
  {
    id: "log_tab",
    label: "種別",
    tab_size: 10,
    type: types.INPUT
  },
  {
    id: "log_id",
    label: "log_id",
    type: types.INPUT
  },
  {
    id: "fk_tab",
    label: "fk_tab",
    type: types.INPUT
  },
  {
    id: "fk_id",
    label: "fk_id",
    type: types.INPUT
  },
  {
    id: "field_name",
    label: "項目",
    tab_size: 10,
    type: types.INPUT
  },
  {
    id: "value_before",
    label: "変更前",
    tab_size: 20,
    type: types.INPUT
  },
  {
    id: "value_after",
    label: "変更後",
    tab_size: 20,
    type: types.INPUT
  },
  {
    id: "status",
    label: "status",
    type: types.INPUT
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_log_history.js